import React from "react";
import { BrowserRouter } from 'react-router-dom';
import AppRouter from "./routes";
import { AuthProvider } from "./features/auth/context/AuthContext";
import ToastContainer from "./shared/ui/notifications/ToastContainer";
import ProgressBar from "./shared/ui/loading/ProgressBar";
const App = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ProgressBar>
          <AppRouter />
        </ProgressBar>
      </BrowserRouter>
      <ToastContainer />
    </AuthProvider>
  );
};

export default App;